// Front-end helpers for starting Pro checkout (2026-09-25).
//
// This does NOT change the payment system. It calls the same existing endpoint
// Account.jsx's goToCheckout() calls (/api/create-checkout-session, POST, with
// the Supabase access token), which still does every server-side check: master
// switch, live keys, "already owns Pro" (409), early coupon, success/cancel URLs.
//
// Why it exists: buy buttons used to send everyone to /account. Signed-in
// buyers had to click buy twice, and signed-out buyers signed in, got
// redirected to /member by the magic link / Google, and lost the purchase.
// Now /pro starts checkout directly when signed in, and a short-lived "intent"
// flag lets <ProCheckoutResume> open checkout right after sign-in.

const INTENT_KEY = "gwrene_pro_checkout_intent";
const INTENT_TTL_MS = 2 * 60 * 60 * 1000; // a sign-in email can take a while

export function setProCheckoutIntent(source = "pro") {
  try {
    localStorage.setItem(INTENT_KEY, JSON.stringify({ at: Date.now(), source }));
  } catch {
    // Private mode / blocked storage: the buyer just lands on /account as before.
  }
}

export function readProCheckoutIntent() {
  try {
    const raw = localStorage.getItem(INTENT_KEY);
    if (!raw) return null;
    const intent = JSON.parse(raw);
    if (!intent?.at || Date.now() - intent.at > INTENT_TTL_MS) {
      localStorage.removeItem(INTENT_KEY);
      return null;
    }
    return intent;
  } catch {
    return null;
  }
}

export function clearProCheckoutIntent() {
  try {
    localStorage.removeItem(INTENT_KEY);
  } catch {
    // ignore
  }
}

// Returns { url } on success or { error, status } on failure. Never throws.
export async function startProCheckout(session) {
  if (!session?.access_token) return { error: "Not signed in.", status: 401 };
  try {
    const response = await fetch("/api/create-checkout-session", {
      method: "POST",
      headers: { Authorization: `Bearer ${session.access_token}` },
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.url) {
      return { error: data.error || "Could not start checkout yet.", status: response.status };
    }
    return { url: data.url };
  } catch {
    return { error: "Could not reach checkout. Check your connection and try again.", status: 0 };
  }
}
